import PersonGroupPersonsTable from './PersonGroupPersonsTable';

export default PersonGroupPersonsTable;
